import { components } from '../../../generated'

export const COUNT_NEW_NOTIFICATIONS_KEY = 'countNewNotifications'

export const NOTIFICATIONS_SETTINGS_KEY = 'notificationsSettings'

export const NOTIFICATIONS_KEY = 'notifications'

export enum NOTIFICATIONS_SERVICE_TYPE {
  OFFICE = 'office',
  JOB = 'job',
  SHOP = 'shop',
  BLOG = 'blog'
}

export enum NOTIFICATION_SETTINGS_VARIANT {
  DISABLED = 'disabled',
  ALL = 'all',
  INTERNAL = 'internal',
  EMAIL = 'email',
  CUSTOM = 'custom'
}

export enum NOTIFICATIONS_SETTINGS_JOB_CATEGORY_VARIANT {
  FEEDBACKS_AND_MESSAGES = 'feedbacks-and-messages',
  LIKES_PROJECTS = 'likes-projects',
  RECOMMENDED_TENDERS = 'recommend-tenders',
  VERIFY_STATUS = 'verify-status',
  PACKET_EXPIRATION_DATE = 'packet-expiration-date'
}

export const NOTIFICATION_SERVICES_TYPE = {
  [NOTIFICATIONS_SERVICE_TYPE.OFFICE]: 'Офис',
  [NOTIFICATIONS_SERVICE_TYPE.JOB]: 'Фриланс и Работа',
  [NOTIFICATIONS_SERVICE_TYPE.SHOP]: 'Проектный маркет',
  [NOTIFICATIONS_SERVICE_TYPE.BLOG]: 'Блог'
}

export const NOTIFICATION_SERVICES_TYPE_OPTIONS = Object.entries(
  NOTIFICATION_SERVICES_TYPE
)

export const NOTIFICATIONS_SETTINGS_SELECT: Record<
  components['schemas']['AlertSettingsValues'],
  string
> = {
  [NOTIFICATION_SETTINGS_VARIANT.DISABLED]: 'Выключены',
  [NOTIFICATION_SETTINGS_VARIANT.ALL]: 'Все оповещения',
  [NOTIFICATION_SETTINGS_VARIANT.INTERNAL]: 'Только внутренние',
  [NOTIFICATION_SETTINGS_VARIANT.EMAIL]: 'Только емейл'
}

export const NOTIFICATIONS_SETTINGS_SELECT_OPTIONS = Object.entries(
  NOTIFICATIONS_SETTINGS_SELECT
)
